import React from 'react';
import { Modal } from 'react-bootstrap';
import { Col, Row, Spinner } from "react-bootstrap";
import { InputCheck } from "./../../components/forms/inputcheckComponent";
import { connect } from "react-redux";
import { ApplicationFormAction } from "./../../redux/actions";
import { getAllSubject } from "./../../apis/tutors";

class SubjectsModal extends React.PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      selectedSub: "maths",
      Allsubject: {},
      subjects: {},
      loader: false,
    };
  }
  componentDidMount = () => {
    this.setState({
      loader: true,
    });
    getAllSubject()
      .then((res) =>
        this.setState({
          Allsubject: res.data,
          loader: false,
        })
      )
      .catch((err) => console.log(err));
    let subjects = this.props?.TutorInfoObj?.step1?.subjects;
    return subjects ? this.setState({ subjects }) : null;
  };

  componentDidUpdate = (prevProps) => {
    return prevProps?.TutorInfoObj?.step1?.subjects !==
      this.props?.TutorInfoObj?.step1?.subjects
      ? this.setState({ subjects: this.props?.TutorInfoObj?.step1?.subjects })
      : null;
  };
  selectSubject = (sub) => {
    this.setState({
      selectedSub: sub,
    });
  };

  SaveAndCancel = () => {
    const { subjects } = this.state;
    let TutorInfoObj = this.props?.TutorInfoObj ? this.props?.TutorInfoObj : {};
    let modeOfTeaching = this.props?.TutorInfoObj?.step1?.modeOfTeaching;
    let willignessToTravel = this.props?.TutorInfoObj?.step1
      ?.willignessToTravel;
    let address = this.props?.TutorInfoObj?.step1?.address;
    let step1 = {
      subjects,
      modeOfTeaching,
      willignessToTravel,
      address,
    };
    this.props.AddTutorInfo({ ...TutorInfoObj, step1 });
    this.props.onclose();
  };

  checkExistObj = (subjects, headTitle, selectedSub) => {
    if (subjects.hasOwnProperty(selectedSub)) {
      if (subjects[selectedSub].hasOwnProperty(headTitle)) {
        return subjects;
      } else {
        subjects[selectedSub][headTitle] = [];
        return subjects;
      }
    } else {
      subjects[selectedSub] = {};
      subjects[selectedSub][headTitle] = [];
      return subjects;
    }
  };

  getInput = (headTitle, title, selectedSub) => {
    let { subjects } = this.state;
    subjects = this.checkExistObj(subjects, headTitle, selectedSub);
    subjects[selectedSub][headTitle].push(title);
    this.setState({
      subjects,
    });
  };
  remove = (headTitle, title, selectedSub) => {
    let { subjects } = this.state;
    subjects[selectedSub][headTitle] = subjects[selectedSub][headTitle]?.filter(
      (subject) => subject !== title
    );
    this.setState({
      subjects,
    });
  };

  scrollToRight = (e) => {
    let scrollStep = 200;
    e.preventDefault();

    var element = document.getElementById("head-title-id");
    let sl = element.scrollLeft,
      cw = element.scrollWidth;

    if (sl + scrollStep >= cw) {
      element.scrollTo(cw, 0);
    } else {
      element.scrollTo(sl + scrollStep, 0);
    }
  };

  scrollToLeft = (e) => {
    let scrollStep = 200;
    e.preventDefault();

    var element = document.getElementById("head-title-id");
    let sl = element.scrollLeft;

    if (sl - scrollStep <= 0) {
      element.scrollTo(0, 0);
    } else {
      element.scrollTo(sl - scrollStep, 0);
    }
  };
    
  render() {
      const { subjectsModal, onclose } = this.props;
      const { selectedSub, subjects, Allsubject, loader } = this.state;
      return (
          <Modal
              size="lg"
              centered
              className="Modal"
              show={subjectsModal} 
              onHide={onclose}
          >

              <Row className="tutoringInterest-Col flex-center-center">
                  <Col lg={12} md={12} sm={12} xs={12} className="modal-content">
                      <Row className="header">
                          <Col
                              lg={1}
                              md={1}
                              sm={1}
                              xs={1}
                              className="flex-start-center back-spanCol"
                          >
                              <button
                                  type="button"
                                  onClick={this.scrollToLeft}
                                  data-dismiss="modal"
                                  style={{
                                      width:"31px",
                                      height:"32px",
                                      outline:"none",
                                      border:"none",
                                      backgroundColor:"white"
                                  }}
                                  >
                                  <span 
                                      aria-hidden="true" 
                                      style={{
                                      transform: "rotate(135deg)",
                                      WebkitTransform: "rotate(135deg)",
                                      border: "solid #2cb46d",
                                      borderWidth: "0 3px 3px 0",
                                      display: "inline-block",
                                      padding: "5px",
                                      backgroundColor:"white"
                                      }}>
                                  </span>
                              </button>
                          </Col>
                          <Col lg={10} md={10} sm={9} xs={9} className="modal-title">
                              <Row className="header_options" id="head-title-id">
                              {Object.keys(Allsubject).map((subject, index) => {
                                  return (
                                  <Col
                                      key={index}
                                      lg={2}
                                      md={2}
                                      sm={2}
                                      xs={2}
                                      style={{ height: "100%", minWidth: "100px" }}
                                  >
                                      <span
                                      className={`sub-txt ${
                                          selectedSub === subject ? "active" : ""
                                      }`}
                                      onClick={() => this.selectSubject(subject)}
                                      >
                                      {subject.charAt(0).toUpperCase() + subject.slice(1)}
                                      </span>
                                  </Col>
                                  );
                              })}
                              </Row>
                          </Col>
                          <Col
                              lg={1}
                              md={1}
                              sm={1}
                              xs={1}
                              className="flex-start-center next-spanCol"
                          >
                              <button
                                  type="button"
                                  onClick={this.scrollToRight}
                                  data-dismiss="modal"
                                  style={{
                                      width:"31px",
                                      height:"32px",
                                      outline:"none",
                                      border:"none",
                                      backgroundColor:"white"
                                  }}
                                  >
                                  <span 
                                      aria-hidden="true" 
                                      style={{
                                      transform: "rotate(-45deg)",
                                      WebkitTransform: "rotate(-45deg)",
                                      border: "solid #2cb46d",
                                      borderWidth: "0 3px 3px 0",
                                      display: "inline-block",
                                      padding: "5px",
                                      backgroundColor:"white"
                                      }}>
                                  </span>
                              </button>
                          </Col>
                      </Row>

                      <div style={{ borderBottom: "1px solid #00000033" }} />

                      <div className="modal-body">
                      {!loader ? (
                          Allsubject && Allsubject[selectedSub] ? (
                          Object.keys(Allsubject[selectedSub]).map((subject, index) => {
                              return (
                              <div key={index} className="modal_subject_Head">
                                  <p className="modal_subject_title">
                                  {subject.charAt(0).toUpperCase() + subject.slice(1)}
                                  </p>
                                  <div className="subject_category_wrap">
                                  <div className="subject_category_item">
                                      {Allsubject[selectedSub][subject].length ? (
                                      Allsubject[selectedSub][
                                          subject
                                      ].map((level, i) => (
                                          <InputCheck
                                          key={i}
                                          selectedSub={selectedSub}
                                          obj={subjects}
                                          headTitle={subject}
                                          title={level}
                                          id={`${subject}${level}${i}`}
                                          getInput={this.getInput}
                                          remove={this.remove}
                                          />
                                      ))
                                      ) : (
                                      <InputCheck
                                          selectedSub={selectedSub}
                                          obj={subjects}
                                          headTitle={subject}
                                          title={"All"}
                                          id={`All${index}`}
                                          getInput={this.getInput}
                                          remove={this.remove}
                                      />
                                      )}
                                  </div>
                                  </div>
                              </div>
                              );
                          })
                          ) : (
                          ""
                          )
                      ) : (
                          <div className="flex-center-center">
                          <Spinner
                              animation="border"
                              style={{ width: "50px", height: "50px" }}
                          />
                          </div>
                      )}
                      </div>

                      <div style={{ borderBottom: "1px solid #00000033" }} />
                      
                      <div className="modal-footer">
                      <div className="row flex-center" style={{ width: "100%" }}>
                          <div className="col-6 text-left">
                          <button
                              className="cancel"
                              onClick={onclose}
                          >
                              Cancel
                          </button>
                          </div>
                          <div className="col-6 text-right">
                          <button
                              className="btn-save"
                              onClick={this.SaveAndCancel}
                          >
                              Save
                          </button>
                          </div>
                      </div>
                      </div>
                  </Col>
              </Row>

          </Modal>
      );
  }
}

const mapStateToProps = (state) => {
    const {
    ApplicationFormReducer: { TutorInfoObj },
    } = state;

    return {
    TutorInfoObj,
    };
};
const mapDispatchToProps = (dispatch) => {
    return {
    AddTutorInfo: (payload) =>
        dispatch(ApplicationFormAction.AddTutorInfo(payload)),
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(SubjectsModal);